export const send2Icon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M22 12L4 20L4.5 16L4.75 14L4.8125 13.5L14 12L4.8125 10.5L4.75 10L4.5 8L4 4L22 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'send-2' as const,
};
